module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"select-field-dialog\" title=\"")
    ; __append(escapeFn(selectFieldTitle))
    ; __append("\" style=\"display: none;\">\r\n    <ul class=\"select-field\">\r\n        ")
    ; 
            var pages = pages || [];
            pages.map(function(page, pageId){
        
    ; __append("\r\n            <li class=\"page-list ")
    ; __append(escapeFn(page.id))
    ; __append(" collapsible\">\r\n                <a href=\"#\" data-target=\"")
    ; __append(escapeFn(page.id))
    ; __append("\" class=\"field-list-toggle\">\r\n                    <i class=\"page-icon fa fa-file-text-o\" alt=\"page icon\" style=\"height: 20px;\r\n                    width: 20px;\r\n                    margin-right: 0;\r\n                    font-family: 'FontAwesome' !important;\r\n                    font-size: 1.5em !important;\r\n                    padding-top: 2px;\"></i>")
    ; __append(escapeFn(page.name))
    ; __append("</a>\r\n                <ul class=\"control-list ")
    ; __append(escapeFn(page.id))
    ; __append("\" style=\"display: none;\">\r\n                    ")
    ; 
                    page.controls.map(function(control, controlId){
                        if (control.selectFields) {
                        
    ; __append("\r\n                        <!-- Controls with select fields -->\r\n                        <li class=\"collapsible\">\r\n                            <a href=\"#\" data-target=\"")
    ; __append(escapeFn(control.id))
    ; __append("\" class=\"field-list-toggle\" id=\"field-select-")
    ; __append(escapeFn( control.id ))
    ; __append("\"\r\n                               data-selected-item=\"")
    ; __append(escapeFn(control.id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(control.name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(control.factoryKey))
    ; __append("\">\r\n                                <i class=\"fa ")
    ; __append(escapeFn(control.icon))
    ; __append("\"></i>\r\n                                ")
    ; __append(escapeFn(control.name ))
    ; __append("\r\n                            </a>\r\n                            <ul class=\"control-list ")
    ; __append(escapeFn(control.id))
    ; __append("\" style=\"display: none;\">\r\n                                ")
    ; 
                                control.selectFields.map(function(selectValue, selectValueId) {
                                    
    ; __append("\r\n                                    <li  style=\"padding-left: 1.3em\">\r\n                                        <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn( control.id ))
    ; __append("-")
    ; __append(escapeFn(selectValue.text.toString().replace(/\s/g, '') ))
    ; __append("\"\r\n                                           data-selected-item=\"")
    ; __append(escapeFn(control.id ))
    ; __append("-")
    ; __append(escapeFn(selectValue.text.replace(/\s/g, '') ))
    ; __append("\"\r\n                                           data-selected-name=\"")
    ; __append(escapeFn(control.name))
    ; __append(" - ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\">\r\n                                            <i class=\"fa ")
    ; __append(escapeFn(control.icon))
    ; __append("\"></i>\r\n                                            ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\r\n                                        </a>\r\n                                    </li>\r\n                                ")
    ; 
                                })
                                   
    ; __append("\r\n                            </ul>\r\n                        </li>\r\n                        ")
    ; 
                        } else {
                        
    ; __append("\r\n                        <!-- Simple Controls -->\r\n                        <li style=\"padding-left: 1.3em\">\r\n                            <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn( control.id ))
    ; __append("\"\r\n                               data-selected-item=\"")
    ; __append(escapeFn(control.id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(control.name))
    ; __append("\"\r\n                               data-selected-key=\"")
    ; __append(escapeFn(control.factoryKey))
    ; __append("\">\r\n                                <i class=\"fa ")
    ; __append(escapeFn(control.icon))
    ; __append("\"></i>\r\n                                ")
    ; __append(escapeFn(control.name ))
    ; __append("\r\n                            </a>\r\n\r\n                        </li>\r\n                        ")
    ; 
                        }
                    });
                    
    ; __append("\r\n                </ul>\r\n            </li>\r\n        ")
    ; 
            });
        
    ; __append("\r\n    </ul>\r\n</div>")
  }
  return __output;

}